import { Image, StyleSheet, Text, View } from '@react-pdf/renderer';

import { GraphImageProps } from './GraphImage.types';

// Create styles
const styles = StyleSheet.create({
  imageContainer: {
    flexGrow: 1,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    maxHeight: 480,
    width: '100%',
    position: 'relative',
  },
  image: {
    objectFit: 'contain',
    objectPosition: 'left top',
  },
});

export default function GraphImage({ src = '' }: GraphImageProps) {
  return (
    <View style={styles.imageContainer}>
      {src ? <Image src={src} style={styles.image} /> : <Text>No-Image</Text>}
    </View>
  );
}
